"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const unique_1 = require("@common/tsutils/unique");
const trans_1 = require("@common/tsutils/trans");
class AlchemyGroup {
    constructor() {
        // The data origin: core, csv or ranks
        this.origin = 'core';
        // The unique ID - lang independent
        this.id = '';
        // The path to retrieve the value in the sample object
        this.sample_path = '';
        this.field = null;
        // Check if the alchemy group can be used
        this.enabled = true;
    }
    get label() {
        return this.getLabel();
    }
    getLabel() {
        if (this.origin === 'core') {
            return (0, trans_1.trans)('heatmap.metadata_items.' + this.id);
        }
        return this.field.name;
    }
    /**
     * This methods takes the possible values of the samples
     * for the particular group
     * and sets the enabled flag if there are valid values
     * @param library
     */
    init(library) {
        const options = library.map(s => {
            return s.retrieveValueForFilterOrGroup(this);
        }).filter(x => {
            return x !== undefined && x !== null;
        }).map(x => {
            return (x + '').trim();
        }).filter(unique_1.uniqueFilter);
        // This will make the filter unselectable
        if (!options.length)
            this.enabled = false;
    }
    static newCore(id, path) {
        const f = new AlchemyGroup();
        f.origin = 'core';
        f.sample_path = path;
        f.id = id;
        return f;
    }
    static newFromCSV(field) {
        const f = new AlchemyGroup();
        f.origin = 'csv';
        f.id = field.id;
        f.field = field;
        return f;
    }
}
exports.default = AlchemyGroup;
